// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import SocialEvent, { processSocialEvent } from "./SocialEvent";
import User, { processUser } from "./User";
import UserRegistrationValue from "./UserRegistrationValue";
import Util from "PreciateUtil";

export default interface UserRegistration {
    registrationId?: string;
    source?: string;
    registeredDateTime?: Date;
    confirmed?: boolean;
    user?: User;
    accountUser?: User;
    event?: SocialEvent;
    values?: UserRegistrationValue[];
    guestBearer?: string;
    refreshBearer?: string;
}

export function processUserRegistration(value?: UserRegistration): void {
  if (value) {
    value.registeredDateTime = Util.toDate((value as any).registeredDateTime);
    processUser(value.user);
    processUser(value.accountUser);
    processSocialEvent(value.event);
  }
}

export function processUserRegistrationArray(array?: UserRegistration[]): void {
  if (array) {
    for (const v of array) {
      processUserRegistration(v);
    }
  }
}
